// extracted by mini-css-extract-plugin
export default {"pdfGeneratorContainer":"pdfgenerator_pdfGeneratorContainer__5zG-I","sectionTitle":"pdfgenerator_sectionTitle__INQ3f","generateButton":"pdfgenerator_generateButton__yo2q+"};